'use client'

import { Spacer, Text } from '@vinted/web-ui'
import { ReactNode } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { HelpCenterFaqEntryUrl } from '@marketplace-web/help-center/help-center-faq-entry-url-feature'
import {
  AccessChannel,
  FaqEntryType,
} from '@marketplace-web/help-center/help-center-faq-entry-url-data'

const ItemCurrencyConversionNote = () => {
  const translate = useTranslate('item')

  const values = {
    'currency-conversion-note-link': (chunks: Array<ReactNode>) => (
      <HelpCenterFaqEntryUrl
        key="currency-conversion-note-link"
        type={FaqEntryType.CrossCurrency}
        accessChannel={AccessChannel.ProductLink}
        render={url => (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            data-testid="cross-currency-faq-entry-link"
          >
            {chunks}
          </a>
        )}
      />
    ),
  }

  return (
    <>
      <Text as="h3" text={translate('currency_conversion_note', values)} type="subtitle" />
      <Spacer size="medium" />
    </>
  )
}

export default ItemCurrencyConversionNote
